import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useLanguage } from "../i18n/LanguageProvider";

const styles = {
  page: {
    width: "92%",
    maxWidth: "980px",
    margin: "0 auto",
    padding:
      "calc(18px + var(--vq-safe-area-top)) calc(16px + var(--vq-safe-area-right)) calc(28px + var(--vq-safe-area-bottom)) calc(16px + var(--vq-safe-area-left))",
    borderRadius: "16px",
    background: "rgba(255,255,255,0.04)",
    border: "1px solid rgba(255,255,255,0.10)",
    color: "white",
    boxSizing: "border-box",
  },
  backButton: {
    background: "transparent",
    border: "1px solid rgba(255,255,255,0.2)",
    color: "#fff",
    padding: "10px 16px",
    borderRadius: "10px",
    cursor: "pointer",
    marginBottom: "30px",
    fontSize: "15px",
  },
  title: {
    marginTop: 0,
    fontSize: "clamp(22px, 5vw, 30px)",
    fontWeight: 900,
    marginBottom: "16px",
    lineHeight: 1.15,
  },
  intro: {
    margin: 0,
    lineHeight: 1.65,
    color: "rgba(255,255,255,0.9)",
    fontSize: "15px",
  },
  introBox: {
    padding: "16px",
    borderRadius: "14px",
    background: "linear-gradient(135deg, rgba(255,0,127,0.12) 0%, rgba(122,43,255,0.10) 100%)",
    border: "1px solid rgba(255,255,255,0.12)",
    boxShadow: "inset 0 1px 0 rgba(255,255,255,0.10)",
  },
  sectionsWrap: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    marginTop: "18px",
  },
  section: {
    padding: "18px",
    borderRadius: "16px",
    background: "linear-gradient(135deg, rgba(255,255,255,0.075) 0%, rgba(255,255,255,0.035) 100%)",
    border: "1px solid rgba(255,255,255,0.14)",
    boxShadow: "0 12px 26px rgba(0,0,0,0.18), inset 0 1px 0 rgba(255,255,255,0.08)",
    boxSizing: "border-box",
  },
  h2: {
    fontWeight: 900,
    margin: 0,
    fontSize: "clamp(19px, 4.3vw, 23px)",
    lineHeight: 1.25,
    color: "#fff",
    paddingBottom: "12px",
    borderBottom: "1px solid rgba(255,255,255,0.12)",
  },
  p: {
    marginTop: "14px",
    marginBottom: 0,
    lineHeight: 1.65,
    color: "rgba(255,255,255,0.9)",
    fontSize: "15px",
  },
  list: {
    marginTop: "14px",
    marginBottom: 0,
    paddingLeft: "24px",
    lineHeight: 1.65,
    color: "rgba(255,255,255,0.9)",
    fontSize: "15px",
  },
};

export default function CompetitionTermsPage({ showBackButton = false, onBack = null, embedded = false }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useLanguage();
  const sections = t("competitionTerms.sections", []);

  const handleBack = () => {
    if (typeof onBack === "function") {
      onBack();
      return;
    }
    if (location.state?.from === "landing") {
      navigate("/landing");
      return;
    }
    navigate("/");
  };

  return (
    <div
      style={{
        ...styles.page,
        ...(embedded
          ? {
              width: "100%",
              maxWidth: "none",
              margin: 0,
              padding: 0,
              border: "none",
              background: "transparent",
            }
          : null),
      }}
    >
      {showBackButton && (
        <button type="button" onClick={handleBack} style={styles.backButton}>
          ← {t("common.back")}
        </button>
      )}

      <h1
        style={{
          ...styles.title,
          ...(embedded
            ? {
                fontSize: "clamp(20px, 4.6vw, 26px)",
                lineHeight: 1.12,
                overflowWrap: "anywhere",
              }
            : null),
        }}
      >
        {t("competitionTerms.title")}
      </h1>
      <div style={styles.introBox}>
        <p style={styles.intro}>{t("competitionTerms.intro")}</p>
      </div>

      {Array.isArray(sections) && (
        <div style={styles.sectionsWrap}>
          {sections.map((section) => (
            <section key={section.title} style={styles.section}>
              <h2 style={styles.h2}>{section.title}</h2>

              {section.blocks.map((block, index) => {
                if (block.type === "ordered") {
                  return (
                    <ol key={`${section.title}-${index}`} style={styles.list}>
                      {block.items.map((item) => (
                        <li key={item}>{item}</li>
                      ))}
                    </ol>
                  );
                }

                if (block.type === "unordered") {
                  return (
                    <ul key={`${section.title}-${index}`} style={styles.list}>
                      {block.items.map((item) => (
                        <li key={item}>{item}</li>
                      ))}
                    </ul>
                  );
                }

                return (
                  <p key={`${section.title}-${index}`} style={styles.p}>
                    {block.text}
                  </p>
                );
              })}
            </section>
          ))}
        </div>
      )}
    </div>
  );
}
